import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';

// Per-person page state saved on the server (migration 210): survives
// sign-out and follows the person to any computer. Keys are fixed on the
// server (uiStateController): kanbanActivitySeen, kanbanColumns,
// kanbanCmFilter, dashboardLook.

export const UI_STATE_QUERY = ['ui-state'];

export const useUiState = () =>
  useQuery(
    UI_STATE_QUERY,
    async () => (await axios.get('/me/ui-state')).data || {},
    { refetchOnWindowFocus: false, staleTime: Infinity },
  );

// Save one key. The cache updates at once; the server write is
// fire-and-forget (a failed save just means it's asked again next time).
export const useSaveUiState = () => {
  const queryClient = useQueryClient();
  return (key, value) => {
    queryClient.setQueryData(UI_STATE_QUERY, (old) => ({ ...(old || {}), [key]: value }));
    axios.put(`/me/ui-state/${key}`, { value }).catch(() => {});
  };
};
